import type { DefaultTheme } from "react-jss";

import { commonLightTheme } from "@/theme/themes/common.light";

export const kfcLightTheme: DefaultTheme = {
  ...commonLightTheme,
  blobStorage: {
    ...commonLightTheme.blobStorage,
    brandLogo:
      "https://assets.markus.live/03-order-app/light/logo/logo-kfc.svg",
  },
  config: {
    ...commonLightTheme.config,
    brandLogoWidth: 78,
    brandLogoHeight: 40,
    sectionsColors: "#FFF2DA;#FFD0A5;#FFE2C7;#FFE3AE;#FFEDCB;#FFD6B0",
  },
} as const;
